import './css/App.css';
import './css/Fonts.css';
import './css/bootstrap.css';
import {App} from './components/App';


export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.ts